import React from 'react'
import { convertWideKanaToHalfKana } from 'utils/commonUtils'
import { useUpdateLog } from 'utils/log'
import { FormTitleProps } from '../items/FormTitle'
import TextAreaLine from '../items/TextAreaLine'
import BaseGroup from './BaseGroup'
import { FormRefarensImageProps } from '../items/FormRefarensImage'

/**
 * TextBoxGroupのタイプ定義
 */
export type TextBoxGroupProps = FormTitleProps &
  FormRefarensImageProps & {
    /** 入力テキスト */
    text: string
    /** プレースホルダ― */
    placeholder?: string
    /** 最大文字数 */
    maxLength?: {
      /** 文字数 */
      length: number
      /** 文字数チェックを半角の文字数で確認するフラグ */
      checkHalfStr?: boolean
    }
    /** 入力可能な文字を制限する時に指定する正規表現 */
    regex?: string
    /** 入力文字変更時のコールバック */
    onChanged?: (value: string) => void
  }

/**
 * テキスト入力グループ
 */
const TextBoxGroup: React.FC<TextBoxGroupProps> = (props) => {
  const {
    title,
    isRequired,
    isOption,
    description,
    caution,
    hideTitle,
    text,
    placeholder,
    maxLength,
    regex,
    onChanged,
    image,
  } = props

  const [inputText, setInputText] = React.useState(text ?? '')

  /** 入力テキストが変更された時のコールバック */
  const handleTextChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
      if (onChanged) {
        const newText = event.target.value
        if (!regex || newText.match(regex)) {
          if (
            maxLength &&
            (maxLength.checkHalfStr
              ? convertWideKanaToHalfKana(newText).length
              : newText.length) > (maxLength?.length ?? -1)
          ) {
            // 最大文字数の指定があり、入力テキストが文字数制限を超えている場合は変更通知を送らない
            return
          }
          setInputText(newText)
          onChanged(newText)
        }
      }
    },
    [maxLength?.length, maxLength?.checkHalfStr, regex, onChanged]
  )

  useUpdateLog(
    title,
    {
      title: title,
      isRequired: isRequired,
      text: text,
    },
    [props]
  )

  return (
    <BaseGroup
      title={title}
      isRequired={isRequired}
      isOption={isOption}
      description={description}
      caution={caution}
      hideTitle={hideTitle}
      image={image}
    >
      <TextAreaLine
        inputText={inputText}
        placeholder={placeholder}
        maxLength={maxLength?.length}
        onChange={handleTextChange}
      />
    </BaseGroup>
  )
}

export default TextBoxGroup
